import {_} from 'i18n'
import React from 'react'

const CircularLoading = () => (
  <div className="spinner-border text-primary spinner-border-sm loader-spinner-container" role="status">
    <span className="sr-only">{_`Carregando...`}</span>
  </div>
)

export default CircularLoading
